import { cpf } from "cpf-cnpj-validator";

export const validateCPF = (cpfValue) => {
  if (!cpfValue) {
    return false;
  }

  const cleanCpf = cpfValue.replace(/\D/g, '');
  return cpf.isValid(cleanCpf);
};

export const validatePassport = (passport) => {
  if (!passport) {
    return false;
  }

  const cleanPassport = passport.replace(/\s/g, '').toUpperCase();
  if (!/^[A-Z0-9]+$/.test(cleanPassport)) {
    return false;
  }

  const length = cleanPassport.length;
  if (length < 6 || length > 9) {
    return false;
  }

  const uniqueChars = new Set(cleanPassport);
  if (uniqueChars.size === 1) {
    return false;
  }

  if (isAscendingSequential(cleanPassport)) {
    return false;
  }

  return !isDescendingSequential(cleanPassport);
};

function isAscendingSequential(passport) {
  for (let i = 1; i < passport.length; i++) {
    if (passport.charCodeAt(i) !== passport.charCodeAt(i - 1) + 1) {
      return false;
    }
  }

  return true;
};

function isDescendingSequential(passport) {
  for (let i = 1; i < passport.length; i++) {
    if (passport.charCodeAt(i) !== passport.charCodeAt(i - 1) - 1) {
      return false;
    }
  }

  return true;
};

export const validateDocument = (document, isInternational, intl) => {
  if (!document) {
    return { isValid: false, message: null };
  }
  
  if (isInternational) {
    const isValid = validatePassport(document);
    return {
      isValid,
      message: isValid
        ? null
        : intl.formatMessage({ id: "error.document_invalid_passport" })
    };
  } else {
    const isValid = validateCPF(document);
    return {
      isValid,
      message: isValid
        ? null
        : intl.formatMessage({ id: "error.document_invalid_cpf" })
    };
  }
};
